'use client';

import { ReactNode } from 'react';

import { SearchCardTabArrivalOrder } from '@/app/(main)/(pages)/busca/[slug]/_components/search-schedules-list/search-card/_components/tabs/arrival-order/search-card-tab-arrival-order.component';
import { SearchCardTabStandalone } from '@/app/(main)/(pages)/busca/[slug]/_components/search-schedules-list/search-card/_components/tabs/standalone/search-card-tab-standalone.component';
import { SearchCardClinicTabScheduled } from '@/app/(main)/(pages)/busca/[slug]/_components/search-schedules-list/search-card/variants/clinic/_components/tabs/scheduled/search-card-clinic-tab-scheduled.component';
import { SearchCardClinicTabFlex } from '@/app/(main)/(pages)/busca/[slug]/_components/search-schedules-list/search-card/variants/clinic/_components/tabs/flex/search-card-clinic-tab-flex.component';
import { SearchCardClinicTabWhatsapp } from '@/app/(main)/(pages)/busca/[slug]/_components/search-schedules-list/search-card/variants/clinic/_components/tabs/whatsapp/search-card-clinic-tab-whatsapp.component';
import { TabsType } from '@/app/(main)/(pages)/busca/[slug]/_hooks/use-schedule-tab.hook';
import { ScheduleType, SearchPartnerData } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { ScheduleTabAnalytics } from '@/app/(main)/(pages)/busca/[slug]/_utils/schedule-tab-analytics.util';

const TAB_CONTENT_BY_KEY: Record<
  TabsType,
  (schedule: SearchPartnerData, tabAnalytics: ScheduleTabAnalytics) => ReactNode
> = {
  [TabsType.SCHEDULED]: (schedule, tabAnalytics) => (
    <SearchCardClinicTabScheduled schedule={schedule} tabAnalytics={tabAnalytics} />
  ),
  [TabsType.ARRIVAL_ORDER]: (schedule, tabAnalytics) => (
    <SearchCardTabArrivalOrder schedule={schedule} tabAnalytics={tabAnalytics} />
  ),
  [TabsType.LABORATORIAL]: (schedule, tabAnalytics) => (
    <SearchCardTabArrivalOrder
      schedule={schedule}
      scheduleType={ScheduleType.LABORATORIAL}
      tabAnalytics={tabAnalytics}
    />
  ),
  [TabsType.FLEX]: (schedule) => <SearchCardClinicTabFlex schedule={schedule} />,
  [TabsType.WHATSAPP]: (schedule) => <SearchCardClinicTabWhatsapp schedule={schedule} />,
  [TabsType.STANDALONE]: (schedule) => <SearchCardTabStandalone schedule={schedule} />,
};

interface ScheduleTabContentProps {
  tabKey: TabsType;
  schedule: SearchPartnerData;
  tabAnalytics: ScheduleTabAnalytics;
}

export function ScheduleTabContent({ tabKey, schedule, tabAnalytics }: ScheduleTabContentProps) {
  return TAB_CONTENT_BY_KEY[tabKey]?.(schedule, tabAnalytics) ?? null;
}
